/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchModelConfigPathParams = NonNullable<operations['patchModelConfig']['parameters']['path']>;

export type PatchModelConfigRequestBody = OperationRequestBodyContent<operations['patchModelConfig']>;

export interface Input extends PatchModelConfigPathParams {
  apiVersion?: string;
  body: PatchModelConfigRequestBody;
}

export async function patchModelConfig(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}/ai-configs/model-configs/{modelConfigKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
